(function(){
  function updateCartCount(){
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
      document.querySelectorAll('.nav__cart .count').forEach(function(el){ el.textContent = cart.item_count || 0; });
    }).catch(function(){});
  }

  var nav = document.getElementById('nav');
  // Cream-background templates need the solid (ink-on-cream) header from the start,
  // otherwise the default cream nav text is invisible until the user scrolls.
  var forceSolidNav = !!document.querySelector('.lb-template--cream, .lb-article-shell, .lb-page-shell');
  function onScroll(){
    if (!nav) return;
    if (forceSolidNav) { nav.classList.add('is-solid'); return; }
    var threshold = window.innerHeight * 0.82;
    if (window.scrollY > threshold) nav.classList.add('is-solid');
    else nav.classList.remove('is-solid');
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  document.querySelectorAll('a[href^="#"]').forEach(function(a){
    a.addEventListener('click', function(e){
      var id = a.getAttribute('href');
      if (!id || id.length < 2) return;
      var el = document.querySelector(id);
      if (el) { e.preventDefault(); window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 10, behavior: 'smooth' }); }
    });
  });

  document.querySelectorAll('[data-lb-paints]').forEach(function(scope){
    var bottle = scope.querySelector('[data-pv-bottle]');
    var body = scope.querySelector('[data-pv-body]');
    var bname = scope.querySelector('[data-pv-bname]');
    var pname = scope.querySelector('[data-pv-name]');
    var price = scope.querySelector('[data-pv-price]');
    var addBtn = scope.querySelector('[data-pv-add]');
    var pvImg = scope.querySelector('[data-pv-img]');
    var buttons = Array.prototype.slice.call(scope.querySelectorAll('.pswatch'));
    if (!buttons.length) return;
    var selected = buttons[0];

    function render(btn){
      if (!btn) return;
      selected = btn;
      var name = btn.dataset.name || '';
      var hex = btn.dataset.color || '#23211c';
      var metal = btn.dataset.metal === 'true';
      var imageUrl = btn.dataset.image || '';
      if (pvImg && imageUrl) {
        pvImg.src = imageUrl;
        pvImg.alt = name + ' — 18 ml acrylic miniature paint';
        pvImg.style.display = 'block';
        if (bottle) bottle.style.display = 'none';
      } else {
        if (pvImg) { pvImg.style.display = 'none'; }
        if (bottle) { bottle.style.display = ''; }
      }
      if (bottle) { bottle.classList.toggle('bottle--metal', metal); bottle.style.setProperty('--c', hex); }
      if (body) body.style.background = metal ? 'linear-gradient(100deg, #f4e6c0 0%, ' + hex + ' 46%, #5d4a26 100%)' : hex;
      if (bname) bname.textContent = name;
      if (pname) pname.textContent = name;
      if (price) price.textContent = btn.dataset.price || '$9.63';
      if (addBtn) {
        addBtn.dataset.href = btn.dataset.href || '';
        addBtn.textContent = btn.dataset.href ? 'Add to cart' : 'View paints';
      }
      buttons.forEach(function(b){ b.classList.toggle('is-active', b === btn); });
    }
    buttons.forEach(function(btn){
      btn.addEventListener('pointerover', function(){ render(btn); });
      btn.addEventListener('focus', function(){ render(btn); });
      btn.addEventListener('click', function(){
        render(btn);
        if (btn.dataset.href) window.location.href = btn.dataset.href;
      });
    });
    var palette = scope.querySelector('.paints__palette');
    if (palette) palette.addEventListener('pointerleave', function(){ render(selected); });
    if (addBtn) addBtn.addEventListener('click', function(){
      window.location.href = addBtn.dataset.href || '/collections/single-paints';
    });
    render(selected);
  });

  // Figures page: client-side search, facet filtering, live counts, sort.
  document.querySelectorAll('[data-lb-figures]').forEach(function(scope){
    var grid = scope.querySelector('[data-lb-fig-grid]');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-lb-fig]'));
    var searchInput = scope.querySelector('[data-lb-fig-search]');
    var filterBtns = Array.prototype.slice.call(scope.querySelectorAll('[data-lb-fig-filter]'));
    var summary = scope.querySelector('[data-lb-fig-active]');
    var totalSummary = scope.querySelector('[data-lb-fig-summary]');
    var noneEl = scope.querySelector('[data-lb-fig-none]');
    var sortSel = scope.querySelector('[data-lb-fig-sort]');
    var clearBtns = Array.prototype.slice.call(scope.querySelectorAll('[data-lb-fig-clear]'));
    var filterToggle = scope.querySelector('[data-lb-fig-filtertoggle]');
    var filtersWrap = scope.querySelector('[data-lb-fig-filters]');
    var active = {};
    var query = '';
    var originalOrder = cards.slice();

    function activeValues(group){ return active[group] || []; }

    function cardMatches(card){
      if (query) {
        var blob = (card.getAttribute('data-search') || '');
        if (blob.indexOf(query) === -1) return false;
      }
      for (var group in active) {
        if (!active[group].length) continue;
        var val = card.getAttribute('data-' + group) || '';
        if (active[group].indexOf(val) === -1) return false;
      }
      return true;
    }

    function labelFor(group, value){
      var btn = filterBtns.filter(function(b){ return b.getAttribute('data-group') === group && b.getAttribute('data-value') === value; })[0];
      if (btn) { var t = btn.querySelector('.lb-figfilter__btn-text'); if (t) return t.textContent; }
      return value;
    }

    function apply(){
      var visible = 0;
      cards.forEach(function(card){
        if (cardMatches(card)) { card.hidden = false; visible++; }
        else { card.hidden = true; }
      });
      // live counts: for each filter button, count cards that would match with that value added
      filterBtns.forEach(function(btn){
        var group = btn.getAttribute('data-group');
        var value = btn.getAttribute('data-value');
        var n = cards.filter(function(card){
          if (query && (card.getAttribute('data-search') || '').indexOf(query) === -1) return false;
          for (var g in active) {
            if (!active[g].length || g === group) continue;
            if (active[g].indexOf(card.getAttribute('data-' + g) || '') === -1) return false;
          }
          return (card.getAttribute('data-' + group) || '') === value;
        }).length;
        var c = btn.querySelector('[data-lb-fig-count]');
        if (c) c.textContent = n ? n : '';
        btn.disabled = n === 0 && !btn.classList.contains('is-active');
        btn.style.opacity = btn.disabled ? '0.4' : '';
      });
      if (noneEl) noneEl.hidden = visible !== 0;
      if (totalSummary) totalSummary.textContent = visible + (visible === 1 ? ' figure' : ' figures');
      // summary line e.g. "Rome · Cavalry — 34 figures"
      if (summary) {
        var parts = [];
        for (var group in active) { active[group].forEach(function(v){ parts.push(labelFor(group, v)); }); }
        if (query) parts.push('“' + query + '”');
        var countText = visible + (visible === 1 ? ' figure' : ' figures');
        summary.textContent = parts.length ? parts.join(' · ') + ' — ' + countText : countText;
      }
    }

    function sortCards(mode){
      var arr = cards.slice();
      if (mode === 'az') arr.sort(function(a,b){ return (a.getAttribute('data-title')||'').localeCompare(b.getAttribute('data-title')||''); });
      else if (mode === 'price-asc') arr.sort(function(a,b){ return (+a.getAttribute('data-price')||0) - (+b.getAttribute('data-price')||0); });
      else if (mode === 'price-desc') arr.sort(function(a,b){ return (+b.getAttribute('data-price')||0) - (+a.getAttribute('data-price')||0); });
      else if (mode === 'chrono') arr.sort(function(a,b){ return (+a.getAttribute('data-chrono')||0) - (+b.getAttribute('data-chrono')||0); });
      else if (mode === 'newest') arr = originalOrder.slice().reverse();
      else arr = originalOrder.slice();
      arr.forEach(function(card){ grid.appendChild(card); });
    }

    filterBtns.forEach(function(btn){
      btn.addEventListener('click', function(){
        var group = btn.getAttribute('data-group');
        var value = btn.getAttribute('data-value');
        active[group] = active[group] || [];
        var idx = active[group].indexOf(value);
        if (idx === -1) { active[group].push(value); btn.classList.add('is-active'); btn.setAttribute('aria-pressed','true'); }
        else { active[group].splice(idx, 1); btn.classList.remove('is-active'); btn.setAttribute('aria-pressed','false'); }
        apply();
      });
    });

    if (searchInput) searchInput.addEventListener('input', function(){ query = searchInput.value.trim().toLowerCase(); apply(); });
    if (sortSel) sortSel.addEventListener('change', function(){ sortCards(sortSel.value); });
    clearBtns.forEach(function(b){ b.addEventListener('click', function(){
      active = {}; query = '';
      if (searchInput) searchInput.value = '';
      filterBtns.forEach(function(x){ x.classList.remove('is-active'); x.setAttribute('aria-pressed','false'); });
      apply();
    }); });
    if (filterToggle && filtersWrap) filterToggle.addEventListener('click', function(){
      var open = filtersWrap.classList.toggle('is-open');
      filterToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    if (sortSel && sortSel.value && sortSel.value !== 'featured') sortCards(sortSel.value);
    apply();
  });

  // Product page: thumbnail gallery swaps the main image.
  document.querySelectorAll('[data-lb-gallery]').forEach(function(scope){
    var main = scope.querySelector('.lb-product-media__img');
    var thumbs = Array.prototype.slice.call(scope.querySelectorAll('[data-lb-gallery-thumb]'));
    if (!main || !thumbs.length) return;
    thumbs.forEach(function(thumb){
      thumb.addEventListener('click', function(){
        var full = thumb.getAttribute('data-full');
        if (full) { main.src = full; main.removeAttribute('srcset'); }
        thumbs.forEach(function(t){ t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });
})();
